module.exports = __webpack_public_path__ + "static/rivvit-logo-f2d253fc1857f7144fe2f6610e216e8a.png";